import React from 'react'

import { useTheme } from '@emotion/react'

import { InputCard } from '../InputCard/InputCard'
import RadioCell, { RadioCellProps } from '../RadioCell/RadioCell'

export type RadioInputCardProps = RadioCellProps
export default React.forwardRef<HTMLDivElement, RadioInputCardProps>(({ ...props }, ref) => {
  const { spacing } = useTheme()

  return (
    <InputCard>
      <RadioCell headerSpacing={spacing.xxs} ref={ref} {...props} />
    </InputCard>
  )
})
